export const hasAdBlock = (): boolean => !document.getElementById('EunvtAmXwroK');